import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Autocomplete,
  TextField,
  CircularProgress,
} from "@mui/material";

const CopyDialog = ({
  open,
  handleClose,
  handleConfirmCopy,
  availableLocations,
}) => {
  const [selectedSchools, setSelectedSchools] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleCopy = async () => {
    setLoading(true);
    await handleConfirmCopy(selectedSchools);
    setLoading(false);
    setSelectedSchools([]);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Copy Principle Question to Schools</DialogTitle>
      <DialogContent>
        <Autocomplete
          multiple
          options={availableLocations}
          getOptionLabel={(option) => option.name}
          onChange={(event, value) =>
            setSelectedSchools(value.map((s) => s._id))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Schools"
              variant="outlined"
              sx={{
                marginTop: "1rem",
              }}
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" disabled={loading}>
          Close
        </Button>
        <Button
          onClick={handleCopy}
          color="primary"
          disabled={selectedSchools.length === 0 || loading}
        >
          {loading ? <CircularProgress size={24} /> : "Copy"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CopyDialog;
